import { render, staticRenderFns } from "./scenic.vue?vue&type=template&id=f52a752a&scoped=true&"
import script from "./scenic.vue?vue&type=script&lang=js&"
export * from "./scenic.vue?vue&type=script&lang=js&"
import style0 from "./scenic.vue?vue&type=style&index=0&id=f52a752a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52a752a",
  null
  
)

export default component.exports